import React from "react";
import "./about.scss";
import who from "../assets/images/who.png";
import { useLanguage } from "../LanguageContext";


const About = () => {
  const { t } = useLanguage();

  return (
    <div className="about">
      <div className="about-container">
        <h1>{t("about_title")}</h1>
        
        <p>{t("about_description")}</p>
      </div>

      <div className="mission-container">
        <div className="mission-text">
          <h2>{t("about_title_2")}</h2>
          <p>{t("about_description_2")}</p>
        </div>
        <div className="mission-image">
          <img src={who} alt="mission" />
        </div>
      </div>

      <div className="founders-container">
        <div className="founders-text">
          <h2>{t("about_title_3")}</h2>
        </div>
        <div className="team-image">
          <img src={who} alt="team" />
        </div>
      </div>
    </div>
  );
};

export default About;
